import React from 'react';
import T from 'prop-types';
import Spinner from '../../components/Spinner/Spinner';
import classnames from 'classnames/bind';
import styles from './Button.mod.css';

let cx = classnames.bind(styles);

const Button = ({
  children,
  type = 'button',
  onClick,
  primary,
  link,
  secondary,
  plain,
  disabled = false,
  className = '',
  isLoading,
  color,
  ...otherProps
}) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };
  const style = color ? { backgroundColor: color } : {};

  return (
    <button
      className={cx('button', className, {
        secondary,
        primary,
        link,
        plain
      })}
      type={type}
      onClick={handleClick}
      disabled={disabled}
      style={style}
      {...otherProps}
    >
      {isLoading ? <Spinner color="white" /> : children}
    </button>
  );
};

Button.propTypes = {
  className: T.string,
  children: T.oneOfType([T.node, T.element]).isRequired,
  type: T.oneOf(['button', 'submit', 'reset']),
  onClick: T.func,
  disabled: T.bool,
  isLoading: T.bool
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.js